module.exports = __webpack_public_path__ + "img/m45_54s_thumb.18e08274.jpg";